export const appConfig = {
  // apiUrl: "http://164.52.192.76:8090/sp-niti-demo",
  // webUrl:"http://localhost:4200/",

  apiUrl: 'https://api.wep.gov.in',
  webUrl:"https://wep.gov.in/",

  // apiUrl: 'https://wepdevapi.g44.in',
  // webUrl:"https://wepdev.g44.in/",
  secret_key: "LyGhlLIQ/YnS64HQvnTX1EQqODd7+0l2C/vXs3m1V9M=",


  // apiUrl: 'http://164.52.192.76:8090/sp-niti-demo-enc-dec'
  // apiUrl : 'http://localhost/laravel/niti-demo'

};